import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.customerDivisions.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.customerDivisions.actionsLoading;
export const getItems = (state:RootState) => state.customerDivisions.items;
export const getItemsSelect = (state:RootState) => state.customerDivisions.dropDownItems;
export const getItemsCount = (state:RootState) => state.customerDivisions.itemsCount;
export const getItemForEdit = (state:RootState) => state.customerDivisions.itemForEdit;
export const getError = (state:RootState) => state.customerDivisions.error;
export const getErrorAction = (state:RootState) => state.customerDivisions.errorAction;
export const validationErrors = (state: RootState) => state.customerDivisions.validationErrors;
